import React from "react";
import { teamMembers } from "../utils/data/teamMembersData";
import { useTranslation } from "react-i18next";

const TeamSection = () => {
  const { t } = useTranslation();

  return (
    <section className="swiss-section">
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">03 / {t("Team")}</span>
        </div>

        <div className="col-span-12 lg:col-span-10">
          <h2 className="text-h2 font-bold tracking-tight text-ink mb-7 max-w-[18ch]">
            {t("Bogowi Team")}
          </h2>

          <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-8">
            {teamMembers.map((member, index) => (
              <li key={index} className="flex flex-col">
                <div className="w-full aspect-[4/5] overflow-hidden bg-ink-6">
                  <img
                    src={typeof member.photo === "string" ? member.photo : (member.photo as string)}
                    alt={member.name}
                    className="w-full h-full object-cover grayscale hover:grayscale-0 transition duration-300"
                  />
                </div>
                <div className="mt-4 border-t border-ink pt-3">
                  <h3 className="text-h4 font-medium tracking-tight text-ink">
                    {member.name}
                  </h3>
                  <p className="swiss-caption mt-2">
                    {member.flag} {t(member.position)}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
